import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppComponent } from './app.component';
import { HttpClientModule } from '@angular/common/http';
import { HomeComponent } from './+home/home.component';


import { CommonModule } from '@angular/common';

import { RouterModule, Router } from '@angular/router';
import { LocationService } from './services/location.service';
import { HttpCssClient } from './shared/http-request.interceptor';
import { routes } from './app.routes';
import { ProductService } from './services/product.service';
import { AccentsUtils } from './shared/accents-utils.service';
import { HrefLang } from './shared/hreflang.service';
import { CheckingUrl } from './shared/checking-url.service';
import { DeviceService } from './shared/device.service';
import { HeaderService } from './shared/header.service';
import { AnalyticsUtilsService } from './shared/analytics-utils.service';
import { CurrencyService } from './shared/currency.service';
import { LanguageInterceptor } from './shared/language-interceptor.service';
import { TransferHttpCacheModule } from '@nguniversal/common';
import { RootInterceptor } from './shared/interceptors/root-interceptor.service';
import { ErrorInterceptor } from './shared/interceptors/error-interceptor';
import { OopsComponent } from './shared/components/oops/oops.component';
import { SharedModule } from './shared/shared.module';
import { BasketModule } from './+basket/basket.module';
import { CityModule } from './+city/city.module';
import { ProductModule } from './+product/product.module';
import { MatNativeDateModule } from '@angular/material/core';
import { PaymentModule } from './+payment/payment.module';
import { AboutModule } from './+about/about.module';
import { FaqModule } from './+faq/faq.module';
import { TermModule } from './+term/term.module';
import { CookieModule } from './+cookie/cookie.module';
import { ContactModule } from './+contact/contact.module';
import { AllDestinationModule } from './+all-destinations/all-destination.module';
import { CompanyPolicyModule } from './+company-policy/company-policy.module';
import { ScrollService } from './shared/scroll-service';
import { ConfirmPaymentModule } from './+confirm-payment/confirm_payment.module';
import { SEOService } from './shared/seo-service';
import { AgentModule } from './+agent/agent.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { WindowScrollService } from './shared/window-sroll.service';
import { AgmCoreModule } from '@agm/core';
import { environment } from '../environments/environment';
import { WindowResizeService } from './shared/window-resize.service';
import { CareersModule } from './+careers/careers.module';
import { HealthCheckModule } from './+health-check/health-check.module';

@NgModule({
  declarations: [
    HomeComponent,
    AppComponent,
    OopsComponent
  ],
  imports: [
    SharedModule,
    HttpClientModule,
    TransferHttpCacheModule,
    CommonModule,
    BrowserAnimationsModule,
    AgentModule,
    BasketModule,
    CityModule,
    ProductModule,
    PaymentModule,
    AboutModule,
    TermModule,
    CookieModule,
    ContactModule,
    ConfirmPaymentModule,
    AllDestinationModule,
    CompanyPolicyModule,
    FaqModule,
    CareersModule,
    HealthCheckModule,
    MatNativeDateModule,
    AgmCoreModule.forRoot({
      apiKey: environment.GOOGLE_KEY,
      apiVersion: '3.32'
    }),
    RouterModule.forRoot(routes, { enableTracing: false })
  ],
  providers: [LocationService, HttpCssClient, ProductService, AccentsUtils, HrefLang, CheckingUrl,
    DeviceService, HeaderService, AnalyticsUtilsService, CurrencyService, LanguageInterceptor,
    RootInterceptor, ErrorInterceptor, ScrollService, SEOService, WindowScrollService, WindowResizeService]
})
export class AppModule { }
